export class Constants {
    static EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    static EMAIL_ORGANIZATION_REGEX = /^[a-z]+[\-a-z0-9]+[a-z0-9]{1,29}$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    static URL_REGEX = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i
    static HTTP_OWNER = 'http@msging.net'
    static CONNECTION_TYPE_ROUTER = 'Router'
    static CONNECTION_TYPE_BUILDER = 'Builder'
    static INFO_TYPE = 'info';
    static WARNING_TYPE = 'warning';
    static SUCCESS_TYPE = 'success';
    static ERROR_TYPE = 'error';
    static DEFAULT_ERROR_TITLE = 'Error';
    static ERROR_NETWORK = 'ERR_NETWORK';
    static SUCCESS_STATUS_CODE = 200;
    static DEFAULT_CERBERUS_TITLE = 'Cerberus';
    static DEFAULT_ERROR_MESSAGE = 'Ops! We had a problem! See on the console.';
    static LIME_URI_PREFIX = 'lime://';
    static RULES_URI = '/rules';
    static DESK_MSGING_URI = 'postmaster@desk.msging.net';
    static DISTRIBUTION_TYPE = 'DistributionType';
    static DISTRIBUTION_TYPE_REDIS = 'Redis';
    static DISTRIBUTION_TYPE_SQL = 'SQL';
    static DISTRIBUTION_TYPE_ORLEANS = 'Orleans';
    static ADMIN_CALLER = 'admin@msging.net';
    static DISTRIBUITION_TYPE_HINT_OK = 'Success';
    static DISTRIBUITION_TYPE_HINT_FAILED = 'The distribution type configuration need attention';
    static CONFIGURATION_APPLICATION = 'Application';
    static CONFIGURATION_APPLICATION_OK = 'Exists';
    static CONFIGURATION_APPLICATION_FAILED = 'The configuration Application not exist for this bot';
    static CONFIGURATION_APPLICATION_OWNER_CONSTRUCTION = 'construction';
    static STATUS_OK = '✅';
    static STATUS_FAILED = '❌';
    static STATUS_WARNING = '⚠️';
    static STATUS_NOT_EXIST_LABEL = 'Not exist';
    static STATUS_DUPLICATED_CONFIG = 'Duplicated configuration';
    static BUILDER_PUBLISHED_FLOW_BUCKET_KEY = 'blip_portal:builder_published_flow';
    static DESK_FLOW = 'Desk Box Count';
    static DESK_FLOW_VERSION = 'Desk Box Version';
    static DESK_FLOW_UPDATED = 'Desk Flow';
    static UPDATED = 'Updated';
    static BOT_FLOW_SIZE = 'Bot Flow Size';
    static WEBHOOK_VALID = 'WhatsApp Configuration';
    static STATUS_VALID = 'Valid';
    static TEMPLATE_CONFIG = 'Template';
    static WABA_CONFIG = 'WhatsAppBusinessAccountId';
    static PHONENUMBER_CONFIG = 'PhoneNumberId';
    static ACCOUNT_EXTERNAL_CONFIG = 'AccountExternalId';
    static BOT_BUILDER = 'builder';
    static BOT_MASTER = 'master';
    static WEBHOOK_DETAILS = 'Webhook';
    static PHONUMBERID_DETAILS = 'PhoneNumberId';
    static WHATSAPP_DETAILS_DESCRIPTION_OK = 'Webhook and PhoneNumberId configurations is valid for the provided bot.';
    static WHATSAPP_DETAILS_DESCRIPTION_FAILED = 'Check your WhatsApp configurations, your webhook or phoneNumberId is not valid.';
    static PLAN_CONSISTENCY = 'Plan Consistency';
    static CONTRACT = 'Contrato';
    static MAX_ROWS_PER_PAGE = 10;
    static ERROR_COLLECTING_PLANS = 'An unexpected error occurred while collecting all plans!';
    static REMOVE_IT = 'Remove it!';
    static ALT_EXPIRATION_DESK_BOX = 'The expiration in Desk blocks can cause unexpected behaviors in agent conversations.';
    static ALT_INVALID_OUTPUT_DESK = 'The desk box has an output set to trigger on any input, which can cause issues with ticket creation.';
    static DESK_EXPIRATION = 'Desk Box With Expiration';
    static DESK_INVALID_OUTPUT = 'Desk Box With a Invalid Output';
    static DESK_BLOCK_PREFIX = 'desk:';
    static CONTRACT_IS_NOT_STRING = 'Contract is not a valid string.';
    static CONTRACT_NORMALIZING_ERROR = 'Error while normalizing contract:';
    static PLAN_MAPPING_NOT_AVAILABLE = 'Plan mapping is not available.';
    static PLAN_MAPPING_INVALID_TYPE = 'PLAN_MAPPING is undefined or not a string. Please check project variables.';
    static PLAN_MAPPING_PARSE_FAIL = 'Error processing plan mapping.';
    static PLAN_MAPPING_CONTRACT_NOT_FOUND = (contract) => `Contract plan '${contract}' not found in plan mapping.`;
    static ERROR_VALIDATING_WEBHOOK = 'Erro ao validar o Webhook. Verifique as configurações.';
    static ALT_TUNNEL_ORIGINATOR_MODIFIED = 'Attention: The flow shows signs of modifications to users tunnel.originator. Review the flow to avoid potential issues. Modifying tunnel.originator or extras.tunnel.originator is not recommended. Check the sub-listing below to see which blocks are involved.';
    static DETECTED_IN_FLOW = 'Detected in Flow';
    static TUNNEL_ORIGINATOR = 'tunnel.originator';
    static MERGECONTACT = 'mergecontact';
    static PROCESSHTTP = 'processhttp';
    static SET = 'set';
    static MERGE = 'merge';
    static EXECUTESCRIPT = 'executescript';
    static TUNNEL_ORIGINATOR_MODIFIED = 'Tunnel Originator Modified';
}